import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Gruhas = () => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(relativePath: { eq: "investors-images/gruhas.png" }) {
          childImageSharp {
            fluid(maxWidth: 3000) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => <Img fluid={data.placeholderImage.childImageSharp.fluid} style={{width: '100%'}}/>}
  />
)
export default Gruhas
